import React, { useState } from 'react';
import InputText from 'app/components/common/InputText/InputText';
import AlignBox from 'app/components/common/AlignBox';
import Button from 'app/components/common/Button';

function JoinFirmDirectContainer({ onSubmit, onClose }) {
	const [firmName, setFirmName] = useState('');
	const [firmNameInvalidMessage, setFirmNameInvalidMessage] = useState('');

	const handleFirmName = (e) => e.target.value.length < 11 && setFirmName(e.target.value);

	const handleSubmit = () => {
		if (!firmName) {
			setFirmNameInvalidMessage('상사명을 입력해주세요.');
			return;
		}
		onSubmit(firmName);
	};

	return (
		<>
			<InputText
				label="상사명"
				useLabelBlind
				type="text"
				id="firmNameDirect"
				name="firmNameDirect"
				value={firmName}
				validation={!!firmNameInvalidMessage}
				validationText={firmNameInvalidMessage}
				placeholder="상사명을 입력해주세요."
				onChange={handleFirmName}
				style={{ marginTop: '20px' }}
			/>
			<AlignBox
				type="float"
				fixed
			>
				<Button
					color="white"
					size="45"
					classArray="bg_white"
					domType="button"
					title="취소"
					onClick={onClose}
				/>
				<Button
					color="red"
					size="45"
					domType="button"
					title="확인"
					onClick={handleSubmit}
				/>
			</AlignBox>
		</>
	);
}

export default JoinFirmDirectContainer;
